import { useRef, useState, useEffect } from "react"
import useScrollDirection from "@/lib/hooks/useScrollDirection"
import { usePathData, useAdminBar } from "@/lib/contexts/appContext"
import { useArchiveContext } from "@/lib/contexts/archiveContext"
import styles from "./school-search-panel.module.css"
import { useRouter } from "next/router"
import { FormProvider, useForm } from "react-hook-form"
import useBreakpoint from "@/lib/hooks/useBreakpoint"
import { SearchControl } from "@/common/form/search-control/search-control"
import classNames from "classnames"

export default function SchoolSearchPanel({ search }) {
  const scrollDirection = useScrollDirection()
  const store = useArchiveContext()
  const formRef = useRef()
  const pathData = usePathData()
  const adminBar = useAdminBar()
  const router = useRouter()

  const [classes, setClasses] = useState([styles.wrapper])

  useEffect(() => {
    store.setLoading(false)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  useEffect(() => {
    setClasses([
      styles.wrapper,
      {
        "no-print": true,
        "has-admin-bar": adminBar
      }
    ])

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pathData])

  const methods = useForm({
    defaultValues: { search: "" },
    mode: "onChange",
    shouldUnregister: true
  })

  const { getValues, handleSubmit, resetField, control } = methods

  const { breakpoint, isMounted } = useBreakpoint()
  const showButtonLoading =
    ["xsm", "sm"].includes(breakpoint) && isMounted && store.getLoading()

  if (scrollDirection === "down") {
    return null
  }

  const onResetCallback = (name) => {
    resetField(name)
  }

  const onSubmit = (_, e) => {
    e.preventDefault()
    store.setLoading(true)
    router.push(
      {
        pathname: search?.url,
        query: { s: getValues("search") }
      },
      null,
      { shallow: false }
    )
  }

  return (
    <div className={classNames(classes)}>
      <div className="inner-wrapper">
        <FormProvider {...methods}>
          <div ref={formRef} className="form-wrapper">
            <form onSubmit={handleSubmit(onSubmit)}>
              <div
                className={classNames(
                  "search-wrapper",
                  "context-" + store.getContext(),
                  search?.panelClass
                )}>
                <SearchControl
                  {...{ control }}
                  isLoading={showButtonLoading}
                  name="search"
                  className="search"
                  onReset={onResetCallback}
                  placeholder={search?.placeholder ?? "Sök i arkivet"}
                  onSubmit={(e) => onSubmit(null, e)}
                />
              </div>
            </form>
          </div>
        </FormProvider>
      </div>
    </div>
  )
}
